module.exports = __webpack_public_path__ + "static/barry-sanders-1012db40b184dcc7d8f2ef6bf3796604.jpeg";